var logger = require("enyo/logger");

/**
 * Responds to a click on a hyperlink.
 *
 * @param   {enyo.Control}  sender  The sender
 * @return  {boolean}       Stop propagation
 * @public
 */
module.exports = function(sender) {
    var $router = this.app.$.router,
        href    = sender.getAttribute("href"),
        target  = sender.getAttribute("target") || "_blank",
        redirect,
        forceRefresh,
        errorMsg;

    // Allow for a redirect instead of adding a new item to the browser history
    if (typeof sender.shouldRedirect === "function") {
        redirect = sender.shouldRedirect();
    }
    else {
        redirect = sender.get("redirect") || false;
    }

    // Tell the router to add a query parameter to provide a hint to controllers
    // they are expected to refresh.
    if (typeof sender.shouldForceRefresh === "function") {
        forceRefresh = sender.shouldForceRefresh();
    }
    else {
        forceRefresh = sender.get("forceRefresh") || false;
    }

    // Empty url
    if (typeof href !== "string" || href === "") {
        return true;
    }

    // Absolute url
    if (href.substring(0, 4) === "http") {
        if (redirect && target === "_self") {
            window.location.replace(href);
        }
        else {
            window.open(href, target);
        }
    }

    // Relative url
    else {
        // Ensure leading slash
        href = href[0] === "/" ? href : "/" + href;

        // Links to a route within the app
        if (href.match(/^\/([a-z]{2})\/([A-Za-z0-9\-._~!$&'()*+,;=:@%/]+)(\?([^#]+)?)?(#(.*))?$/)) {
            redirect ? $router.redirect(href, forceRefresh) : $router.navigate(href, forceRefresh);
        }

        // Bad link format
        else {
            errorMsg = "onHyperlinkTap: Invalid url `" + href + "`";
            logger.error(errorMsg);

            if (typeof Sentry !== "undefined") {
                Sentry.captureException(new Error(errorMsg));
            }
        }
    }

    return true;
};
